import { render, staticRenderFns } from "./EditarProducto.vue?vue&type=template&id=5f90efb6&scoped=true&"
import script from "./EditarProducto.vue?vue&type=script&lang=js&"
export * from "./EditarProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f90efb6",
  null
  
)

export default component.exports